module.exports = __webpack_public_path__ + "img/sliderIcon5.4fbd2d08.png";